import { FlowConfig } from '../types';

export const instantInkFlowConfig: FlowConfig = {
  step1: {
    path: '/ii',
    requirements: [],
  },
  step2: {
    path: '/pdp-config',
    requirements: ['goToPrinterSelection'],
  },
  step3: {
    path: '/cart',
    requirements: [],
  },
  step4: {
    path: '/tenant-selector',
    private: true,
    requirements: ['hasMoreThanOneTenant'],
  },
  step5: {
    path: '/claim',
    private: true,
    requirements: ['redirectToClaim'],
  },
  step6: {
    path: '/checkout',
    private: true,
    requirements: [],
  },
  step7: {
    path: '/order',
    private: true,
    requirements: [],
  },
};
